// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"CY-z","inlineTitle":"DY-z","sponsoredAdsWrapper":"EY-z","marketplaceRecosWrapper":"FY-z"};